import { SellerDelivery } from 'components/sellers/SellerDelivery/SellerDelivery'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { appSelectors } from 'store/app'

export const ProfileDelivery: React.FC = () => {
  const sellerId = useAppSelector(appSelectors.selectSellerId)
  return <SellerDelivery type='profile' sellerId={sellerId ?? ''} />
}
